module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-source-page"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '进销存数据 ' + _vm.preDay
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.showJxcDatas,
      "columns": _vm.jxcThs,
      "mergeRowKeyList": ['加油站名称', '油品名称'],
      "s_key": ['出库升数', '期末库存', '空容']
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48b5c49a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/area_jxc.vue
// module id = 979
// module chunks = 1